import { BackIcon } from '../../icons/icons';
import './BackToComponentButton.css';

interface BackToComponentButtonProps {
    onBackClick: () => void;
}

export const BackToComponentButton = ({
    onBackClick,
}: BackToComponentButtonProps) => {
    return (
        <div
            className='back-to-component d-flex align-items-center'
            onClick={onBackClick}
            data-testid={'back-to-component-button'}
        >
            <BackIcon />
        </div>
    );
};
